export const compare = {
  Duplicate: "Duplicar",
} as const;
